import {ExportTypesEnum} from '../../enums';

export const exportTypes = [
  {
    name: 'Data file',
    type: ExportTypesEnum.DataFile,
  },
];
